import {Container, Button, Row, Offcanvas } from 'react-bootstrap'
import {useState, useEffect} from 'react'
import Meditation from './Meditation'
import Axios from 'axios'
import MeditationCreateForm from './MeditationCreateForm'
import MeditationEditModal from './MeditationEditModal'

//Richard @25.7.22 Sounds Component - authenticate spotify account
import Sounds from '../components/Sounds'



export default function MeditationList(props) {

    const [meditations, setMeditations] = useState([])
    const [isEdit, setIsEdit] = useState(false);
    const [currentMeditation, SetCurrentMeditation] = useState("");
    const [modalShow, setModalShow] = useState(false);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    useEffect(() => {
        loadMeditationList()
    }, [])

    const loadMeditationList = () =>{
        Axios.get("meditation/index", {  // url for API
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }) 
        .then((response) => {
            console.log(response);
            setMeditations(response.data.meditations)
        })
        .catch((error) => {
            console.log(error)
        })
    }
    // const loadJournalList = (meditation) => {
    //     console.log(meditation)
    //     if(meditation.journal){
    //         const journal =  meditation.journal.map((item, key) => (
    //             <td key={key}>
    //             <li> {item.name} </li>
    //             </td>
    //         ));
    //      return journal;
    //     }
    // }
    
    const addMeditation = (meditation) => {
        Axios.post("meditation/add", meditation, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            props.handleSuccessMessage("Meditation Added Successfully!")
            loadMeditationList();
        })
        .catch(error => {
            props.handleErrorMessage("Error Adding Meditation!!!");
        })
    }
    
    const editView = (id) => {
        Axios.get(`meditation/edit?id=${id}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            console.log("Loaded Meditation Information!")
            console.log(response.data.meditation)
            var meditation = response.data.meditation
            setIsEdit(true)
            SetCurrentMeditation(meditation)
        })
        .catch(error => {
            props.handleErrorMessage("Error Loading Meditation Information")
        })
    }
    
    const editMeditation = (meditation) => {
        Axios.put("meditation/update", meditation, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            props.handleSuccessMessage("Meditation Updated")
            loadMeditationList();
        })
        .catch(error => {
            props.handleErrorMessage("Error Editing Meditation")
        })
    }
    
    
    const deleteMeditation = (id) => {
        Axios.delete(`meditation/delete?id=${id}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            props.handleSuccessMessage("Meditation Deleted Successfully!")
            loadMeditationList();
        })
        .catch(error => {
            props.handleErrorMessage("Error Deleting Meditation!")
        })
    }
    
    

    
    const allMeditations = meditations.map((meditation, index) => (
        <div key={index}>
            <Meditation {...meditation} meditation={meditation} editView={editView} deleteMeditation={deleteMeditation} setModalShow={setModalShow} index={index} currentUser={props.currentUser}/>
        </div>
    ))

      return (
        <div>
            <h1>
                Choose Meditation&nbsp; 
                <Button variant="outline-danger" size="sm" onClick={handleShow} className="me-2">
                    Create New Meditation
                </Button>
            </h1>

                {
                    meditations.length === 0 ? 
                <p>You don't have meditations, create a meditation to see the timer and start journaling.</p> 
                : 
                <p>Click on a meditation to see the timer</p>
                
                }

            <Offcanvas show={show} onHide={handleClose} responsive="lg">
                <Offcanvas.Header closeButton>
                <Offcanvas.Title></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                <MeditationCreateForm addMeditation={addMeditation} onHide={handleClose}></MeditationCreateForm>
                </Offcanvas.Body>
            </Offcanvas>


            <Container>
                <Row xs={1} sm={1} md={2} lg={3} xl={3} xxl={4} className="g-4">
                {allMeditations}
                </Row>
            </Container>
            {
                <MeditationEditModal currentMeditation={currentMeditation} key={currentMeditation._id} meditation={currentMeditation} editMeditation={editMeditation} show={modalShow}
                onHide={() => setModalShow(false)}></MeditationEditModal>
            }

            {/* <Sounds /> */}
        </div>
      )
}


